export default __webpack_public_path__ + "static/media/baby-3.ffe75a96.jpeg";